import React from "react";
import Routes from "./routes";
import { FormResultsProvider } from "./hooks/form-results";

import "./assets/css/vendor.css";
import "./assets/css/flat-admin.css";
import "./assets/css/theme/blue.css";
import "./assets/css/style.css";
import InstallButton from "./components/pwaInstaller/InstallButton";

const App = () => (
    <FormResultsProvider>
        <>
            <Routes />
            <InstallButton />
        </>
    </FormResultsProvider>
);
export default App;
